import React from "react";
import "./Visualizer.scss";

const Visualizer = ({ isSpeaking }) => {
  return (
    <div className={`boxContainer ${isSpeaking ? "active" : "inactive"}`}>
      <div className="box box1"></div>
      <div className="box box2"></div>
      <div className="box box3"></div>
      <div className="box box4"></div>
      <div className="box box5"></div>
    </div>
  );
};

export default Visualizer;

